import { useState } from "react";

export function useForceRender() {
  const [counter, setCounter] = useState(0);

  const rerender = () => setCounter((prev) => prev + 1);

  return {
    counter,
    rerender,
  };
}
